import { useMemo } from 'react';
import { base64ToUtf8 } from '@/utils/base64.ts';
import { formatToPhoneNumber } from '@/utils/format.phone.ts';
import { User } from '@/api/event.types.ts';
import useEventEnterQuery from './useTermsEnterQuery';

export const useEventUserInfo = (eventId: string): User => {
  const { data } = useEventEnterQuery(eventId);

  return useMemo(
    () => ({
      name: base64ToUtf8(data.user.name),
      ctn: formatToPhoneNumber(base64ToUtf8(data.user.ctn)),
      isAvailable: data.user.isAvailable,
    }),
    [data.user],
  );
};

export const useEventAvailable = (eventId: string): boolean => {
  const { data } = useEventEnterQuery(eventId);
  return data.user.isAvailable;
};
